import { CommentReportReason } from '@pelando/components/modules';

import { ProfileOffer } from './Offer';
import { Reason } from './Reason';
import { User } from './User';

export enum CommentStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  MODERATED = 'MODERATED',
  PENDING = 'PENDING',
}

export enum ReferrerType {
  COMMENT_CONTENT = 'COMMENT_CONTENT',
  OFFER_DESCRIPTION = 'OFFER_DESCRIPTION',
}

export enum ReactionType {
  LIKE = 'LIKE',
  FUNNY = 'FUNNY',
  HELPFUL = 'HELPFUL',
}

export enum CommentSortOptionsV2 {
  HELPFUL = 'HELPFUL',
  NEWER = 'NEWER',
  OLDER = 'OLDER',
}

export type Reactions = {
  like: number;
  funny: number;
  helpful: number;
};

export type CommentTimestamp = {
  createdAt: string;
  updatedAt?: string;
  approvedAt?: string;
  firstApprovedAt?: string;
};

export type CommentAuthor = Pick<
  User,
  'id' | 'image' | 'nickname' | 'isVerified'
> & {
  id: string;
  nickname: string;
  authorImage: string;
  profileURL: string;
  isVerified: boolean;
};

type OfferInfo = {
  id: string;
  title: string;
};

export type Comment = {
  id: string;
  liked: boolean;
  content: string;
  likeCount: number;
  status: CommentStatus;
  isEdited: boolean;
  parentId?: string;
  timestamps: CommentTimestamp;
  author: CommentAuthor;
  totalReplies: number;
  replyTo?: Omit<Comment, 'replyTo'>;
  deletionReasons?: Reason[];
  reacted?: ReactionType;
  reactions?: Reactions;
  totalReactionsCount: number;
  offer: OfferInfo;
};

export type ReportedComment = {
  id: string;
  status: CommentStatus;
  commentReportReason: CommentReportReason;
};

export type ProfileComment = Pick<
  Comment,
  'id' | 'content' | 'timestamps' | 'status'
> & { offer: ProfileOffer };

export type CommentCache = {
  commentId?: string;
};
